<template>
  <div id="jushuitanStudy">
    <el-tabs v-model="tabCurrent" tab-position="left" @tab-click="handleTabClick">
      <el-tab-pane v-for="chapter in chapters" :key="chapter.key" :name="chapter.key">
        <div slot="label" class="tab-slot">
          <p class="title">{{ chapter.title }}</p>
          <div class="hover-con">
            <p><i class="el-icon-video-play"></i></p>
            <p>点击学习</p>
          </div>
        </div>

        <div v-if="chapter.key === 'first' && state.videoGateVisible" class="startvideo">
          <div class="tip">
            <p><i class="el-icon-video-play"></i></p>
            <p><a class="startstudy" @click="startVideo">开始学习</a></p>
          </div>
        </div>

        <div v-show="!state.practiceVisible" class="video-box">
          <video
            :ref="'video-' + chapter.key"
            :src="chapter.videoUrl"
            controls="controls"
            class="video"
            @play="onVideoPlay"
            @ended="onVideoEnded(chapter.key)"
          >
            您的浏览器不支持 video 标签。
          </video>
        </div>

        <div v-if="state.videoCompleted && !state.practiceVisible" class="stoptip">
          <div class="tip">
            <span class="el-icon-success"></span>
            <p>视频学习完毕，根据提示实操练习</p>
            <p>
              <a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
              <a class="startstudy" @click="startStudy">开始实操练习</a>
            </p>
          </div>
        </div>

        <div v-show="state.practiceVisible" class="content">
          <div class="con-left">
            <JstErpLoginScene
              v-if="chapter.key === 'first'"
              :ref="'scene-' + chapter.key"
              @step-change="onStepChange"
              @guard-failed="onGuardFailed"
              @finish="onFinish"
            />
            <JstErpSecondScene
              v-else-if="chapter.key === 'second'"
              :ref="'scene-' + chapter.key"
              @step-change="onStepChange"
              @guard-failed="onGuardFailed"
              @finish="onFinish"
            />
            <JstErpCreateAftersaleScene
              v-else-if="chapter.key === 'third'"
              :ref="'scene-' + chapter.key"
              @step-change="onStepChange"
              @guard-failed="onGuardFailed"
              @finish="onFinish"
            />
            <JstErpOrderQueryScene
              v-else-if="chapter.key === 'four'"
              :ref="'scene-' + chapter.key"
              @step-change="onStepChange"
              @guard-failed="onGuardFailed"
              @finish="onFinish"
            />
            <JstErpPlaceholderScene v-else />
          </div>
          <aside class="con-right">
            <h3><span class="line"></span>提示</h3>
            <div :class="{ 'compact-tip': tabCurrent === 'third' && rightTipStep === 'create-wrong-exchange' }" v-html="rightTip"></div>
          </aside>
        </div>

        <div v-if="state.practiceCompleted" class="stoptip practice-finish">
          <div class="tip">
            <span class="el-icon-success"></span>
            <p>{{ isLastChapter ? '聚水潭实操完成' : '实操通关，进入下一关吧' }}</p>
            <p>
              <a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重练</a>
              <a v-if="!isLastChapter" class="startstudy" @click="studyNext">GO，下一关</a>
            </p>
          </div>
        </div>

        <div class="study-box">
          <h3><span class="line"></span>查看学习资料</h3>
          <el-row>
            <el-col :span="20">
              <img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')" />
              <div class="con-box">
                <p>{{ chapter.pptTitle }}</p>
                <p>
                  <a v-if="isOpenPpt[chapter.key]" class="btn-open" @click="viewPpt(chapter.key, false)">点击收起</a>
                  <a v-else class="btn-open" @click="viewPpt(chapter.key)">点击展开</a>
                </p>
              </div>
            </el-col>
            <el-col :span="4">
              <el-button v-if="state.videoCompleted && !state.practiceVisible" type="primary" class="pull-right startbtn" @click="startStudy">开始练习</el-button>
            </el-col>
          </el-row>
          <div :id="chapter.pdfViewerId"></div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PDFObject from '../../assets/js/pdfobject.min'
import JstErpLoginScene from './jushuitan/JstErpLoginScene.vue'
import JstErpSecondScene from './jushuitan/JstErpSecondScene.vue'
import JstErpCreateAftersaleScene from './jushuitan/JstErpCreateAftersaleScene.vue'
import JstErpOrderQueryScene from './jushuitan/JstErpOrderQueryScene.vue'
import JstErpPlaceholderScene from './jushuitan/JstErpPlaceholderScene.vue'

const BASE_VIDEO_URL = 'http://taojinyun.file.itaojin.cn/qianniusource/202412/'
const BASE_PDF_URL = '//res.study.itaojin.cn/2024-12/661361ebec2f434fb859625f84480ea0.pdf'
const CHAPTERS = [
  { key: 'first', title: '1、登记无条件信息', videoUrl: BASE_VIDEO_URL + 'step1.mp4', pptTitle: '聚水潭ERP练习-登记无条件信息.ppt', pdfViewerId: 'jst_pdf_viewer_1', implemented: true },
  { key: 'second', title: '2、手工创建售后单', videoUrl: BASE_VIDEO_URL + 'step2.mp4', pptTitle: '聚水潭ERP练习-手工创建售后单.ppt', pdfViewerId: 'jst_pdf_viewer_2', implemented: true },
  { key: 'third', title: '3、创建售后', videoUrl: BASE_VIDEO_URL + 'step3.mp4', pptTitle: '聚水潭ERP练习-创建售后.ppt', pdfViewerId: 'jst_pdf_viewer_3', implemented: true },
  { key: 'four', title: '4、订单查询', videoUrl: BASE_VIDEO_URL + 'step4.mp4', pptTitle: '聚水潭ERP练习-订单查询.ppt', pdfViewerId: 'jst_pdf_viewer_4', implemented: true }
]

export default {
  name: 'JuShuiTanErpStudy',
  components: { JstErpLoginScene, JstErpSecondScene, JstErpCreateAftersaleScene, JstErpOrderQueryScene, JstErpPlaceholderScene },
  data() {
    const isOpenPpt = {}
    CHAPTERS.forEach(chapter => { isOpenPpt[chapter.key] = false })
    return {
      chapters: CHAPTERS,
      tabCurrent: 'first',
      isOpenPpt,
      rightTip: '',
      rightTipStep: '',
      finishTimer: null,
      showLoginPassword: false,
      state: {
        videoGateVisible: true,
        videoCompleted: false,
        practiceVisible: false,
        practiceCompleted: false
      }
    }
  },
  computed: {
    currentChapter() {
      return this.chapters.find(chapter => chapter.key === this.tabCurrent) || this.chapters[0]
    },
    isLastChapter() {
      return this.tabCurrent === this.chapters[this.chapters.length - 1].key
    }
  },
  beforeDestroy() {
    this.clearFinishTimer()
  },
  methods: {
    getCurrentVideo() {
      const videoRef = this.$refs['video-' + this.tabCurrent]
      return Array.isArray(videoRef) ? videoRef[0] : videoRef
    },
    getCurrentScene() {
      const sceneRef = this.$refs['scene-' + this.tabCurrent]
      return Array.isArray(sceneRef) ? sceneRef[0] : sceneRef
    },
    startVideo() {
      const video = this.getCurrentVideo()
      if (video) video.play()
    },
    onVideoPlay() {
      this.state.videoGateVisible = false
    },
    onVideoEnded() {
      this.state.videoCompleted = true
    },
    restartVideo() {
      const video = this.getCurrentVideo()
      if (!video) return
      video.currentTime = 0
      video.play()
      this.state.videoCompleted = false
    },
    startStudy() {
      this.clearFinishTimer()
      const video = this.getCurrentVideo()
      if (video) video.pause()
      this.state.videoCompleted = false
      this.state.practiceVisible = true
      this.state.practiceCompleted = false
      this.showLoginPassword = false
      this.addRecord('START')
      this.$nextTick(() => {
        const scene = this.getCurrentScene()
        if (scene && scene.reset) scene.reset()
      })
    },
    onStepChange(stepId, step, tip) {
      this.rightTipStep = stepId
      this.rightTip = tip || ''
      if (stepId !== 'login') this.showLoginPassword = false
    },
    onGuardFailed(res) {
      this.$alert(res && res.msg ? res.msg : '校验未通过')
    },
    onFinish() {
      this.addRecord('END', this.isLastChapter ? this.finishCourse : null)
      this.clearFinishTimer()
      this.finishTimer = setTimeout(() => {
        this.finishTimer = null
        this.state.practiceCompleted = true
      }, 2000)
    },
    restartStudy() {
      this.clearFinishTimer()
      this.state.practiceCompleted = false
      this.showLoginPassword = false
      this.addRecord('START')
      const scene = this.getCurrentScene()
      if (scene && scene.reset) scene.reset()
    },
    studyNext() {
      const currentIndex = this.chapters.findIndex(chapter => chapter.key === this.tabCurrent)
      const nextChapter = this.chapters[currentIndex + 1]
      if (!nextChapter) return
      this.tabCurrent = nextChapter.key
      this.resetChapterState(nextChapter.key)
    },
    finishCourse() {
      if (window.parent && typeof window.parent.goBack === 'function') {
        window.parent.goBack()
      }
    },
    handleTabClick() {
      this.resetChapterState(this.tabCurrent)
    },
    resetChapterState(tabKey) {
      this.clearFinishTimer()
      const currentVideo = this.getCurrentVideo()
      if (currentVideo) {
        currentVideo.pause()
        currentVideo.currentTime = 0
      }
      this.state.videoGateVisible = tabKey === 'first'
      this.state.videoCompleted = false
      this.state.practiceVisible = false
      this.state.practiceCompleted = false
      this.rightTip = ''
      this.rightTipStep = ''
      this.showLoginPassword = false
      Object.keys(this.isOpenPpt).forEach(key => { this.isOpenPpt[key] = false })
    },
    clearFinishTimer() {
      if (!this.finishTimer) return
      clearTimeout(this.finishTimer)
      this.finishTimer = null
    },
    addRecord(exerciseAction, onSuccess) {
      const stepSeq = this.chapters.findIndex(chapter => chapter.key === this.tabCurrent) + 1
      const data = {
        exerciseType: 'WORKORDER_JUSHUITAN',
        stepSeq,
        exerciseAction
      }
      this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res => {
        const result = res.data
        if (result && result.success) {
          if (exerciseAction === 'END' && this.isLastChapter) {
            this.submitKnowledgeRecord(onSuccess)
          } else if (onSuccess) {
            onSuccess()
          }
        } else {
          this.$message({
            message: (result && result.msg) || '记录练习进度失败',
            type: 'error',
            center: true,
            duration: 1000
          })
        }
      }, () => {
        this.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 1000
        })
      })
    },
    submitKnowledgeRecord(onSuccess) {
      const knowledgeId = this.$route.query.knowledgeId
      const courseId = this.$route.query.courseId
      if (!knowledgeId || !courseId) {
        if (onSuccess) onSuccess()
        return
      }
      const param = {
        assitant: 'assitantNotNull_force_passRecord',
        knowledgeId,
        courseId
      }
      this.$http.post(API_ROOT.college + '/course/submitKnowledgeXlk', param).then(res => {
        const result = res.data
        if (result && result.success) {
          if (onSuccess) onSuccess()
        } else {
          this.$message({
            message: (result && result.msg) || '记录知识点完成状态失败',
            type: 'error',
            center: true,
            duration: 1000
          })
        }
      }, () => {
        this.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 1000
        })
      })
    },
    viewPpt(tabKey, collapse) {
      const chapter = this.chapters.find(item => item.key === tabKey)
      if (!chapter) return
      if (this.isOpenPpt[tabKey] || collapse === false) {
        this.$set(this.isOpenPpt, tabKey, false)
        const viewer = document.getElementById(chapter.pdfViewerId)
        if (viewer) viewer.style.height = '0'
        return
      }
      this.$set(this.isOpenPpt, tabKey, true)
      this.$nextTick(() => {
        const viewer = document.getElementById(chapter.pdfViewerId)
        if (!viewer || !PDFObject.supportsPDFs) return
        viewer.style.height = '700px'
        PDFObject.embed(BASE_PDF_URL, '#' + chapter.pdfViewerId, {
          pdfOpenParams: { navpanes: 0, toolbar: 0, statusbar: 0, view: 'FitV', pagemode: 'thumbs', page: 1 },
          forcePDFJS: true,
          PDFJS_URL: '//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html'
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
#jushuitanStudy { position: relative; box-sizing: border-box; min-height: 100vh; padding: 10px; color: #454545; background: #f1f5f8; }
/deep/ .el-tabs__content { min-height: calc(100vh - 20px); overflow: visible; }
/deep/ .el-tabs__header.is-left { min-height: calc(100vh - 20px); margin-right: 10px; }
/deep/ .el-tabs__item { box-sizing: border-box; width: 180px; height: auto; padding: 10px; color: #454545; text-align: center; }
/deep/ .el-tabs__item.is-active { color: #fff; background: #4c75f1; }
/deep/ .el-tabs__item.is-active .hover-con { display: block; }
/deep/ .el-tabs__active-bar { background: #4c75f1; }
.tab-slot p { margin: 0; line-height: 30px; }
.tab-slot .title { text-align: left; }
.hover-con { display: none; }
/deep/ .el-tabs__item.is-active .hover-con { display: flex !important; flex-direction: column; align-items: center; justify-content: center; }
.hover-con p { width: 100%; margin: 0; text-align: center; }
.hover-con .el-icon-video-play { display: block; font-size: 36px; line-height: 42px; }
.video-box { position: relative; width: 100%; line-height: 0; background: #000; }
.video { display: block; width: 100%; max-height: calc(100vh - 20px); }
.startvideo, .stoptip { position: absolute; z-index: 10; top: 0; right: 0; display: flex; align-items: center; justify-content: center; width: 100%; min-height: 598px; height: calc(100vh - 20px); color: #2b2b2b; text-align: center; background: rgba(127, 127, 127, .5); }
.startvideo .tip, .stoptip .tip { box-sizing: border-box; width: 360px; min-height: 240px; padding: 45px 26px; font-size: 16px; font-weight: bold; background: #fff; border-radius: 5px; }
.startvideo .tip > p, .stoptip .tip > p { margin: 15px 0; }
.startvideo .el-icon-video-play { color: #4c75f1; font-size: 36px; }
.stoptip > .tip > span { color: #3fde3f; font-size: 40px; }
.startstudy, .restart { display: inline-block; box-sizing: border-box; width: 130px; height: 38px; color: #fff; line-height: 36px; background: #4c75f1; border: 1px solid #4c75f1; cursor: pointer; }
.restart { margin-right: 5px; color: #4c75f1; background: #fff; }
.restart .el-icon-refresh-left { padding-right: 5px; font-size: 20px; vertical-align: -2px; }
.content { display: flex; min-height: calc(100vh - 142px); color: #2b2b2b; background: #f1f5f8; }
.con-left { flex: 1 1 auto; min-width: 0; overflow: auto; background: #fff; }
.con-right { flex: 0 0 170px; box-sizing: border-box; min-width: 0; min-height: calc(100vh - 142px); padding: 10px; margin-left: 10px; overflow: auto; font-size: 14px; line-height: 26px; overflow-wrap: anywhere; word-break: break-all; background: #fff; }
.con-right .compact-tip { font-size: 12px; line-height: 20px; }
.con-right h3 { margin: 0 0 12px; font-size: 16px; }
.con-right p { margin: 0 0 8px; }
.con-right /deep/ * { box-sizing: border-box; max-width: 100%; }
.con-right .el-button--primary { background: #4c75f1; border-color: #4c75f1; }
.credential { color: red; font-weight: normal; }
.line { display: inline-block; width: 4px; height: 20px; margin-right: 2px; vertical-align: text-bottom; background: #4c75f1; }
.practice-finish { z-index: 20; }
.study-box { float: left; box-sizing: border-box; width: 100%; padding: 10px; margin-top: 10px; background: #fff; }
.study-box h3 { margin: 0 0 4px; font-size: 16px; }
.img-box { display: block; float: left; width: 40px; padding-top: 15px; margin-bottom: 10px; }
.con-box { padding-top: 10px; padding-left: 50px; margin-bottom: 10px; }
.con-box p { margin: 0; line-height: 24px; }
.btn-open { display: inline-block; padding: 2px 15px; margin-top: 5px; color: #fff; background: #4c75f1; border-radius: 3px; cursor: pointer; }
.startbtn { margin-top: 22px; margin-right: 10px; background: #4c75f1; border-color: #4c75f1; }
@media (max-width: 860px) { #jushuitanStudy { min-width: 760px; } }
</style>



// WEBPACK FOOTER //
// ./src/page/simulate/juShuiTanErpStudy.vue